import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import {
  timezones,
  daylightMinutes,
  daylightWeekNumbers,
  offsetMinutes,
  daylightMode,
  weekdays,
  months,
  hours,
} from "data/timezones.js";
import Select from "react-select";
import SelectComponent from "components/Utils/select.js";
import { MainContext } from "context/MainContext.js";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const TimezoneEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  let formError = false;

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  const [selectedDevices, setSelectedDevices] = useState(
    location.state ? location.state.value : ""
  );

  const [timezoneValues, setTimezoneValues] = useState({
    position: "",
    hours: "",
    minutes: "",
    acronym: "",
    dlMode: "",
    dlStartWeek: "",
    dlEndWeek: "",
    dlStartDay: "",
    dlEndDay: "",
    dlStartMonth: "",
    dlEndMonth: "",
    dlStartHours: "",
    dlEndHours: "",
    dlStartMinutes: "",
    dlEndMinutes: "",
    dlStartDate: "",
    dlEndDate: "",
    dlStartYear: "",
    dlEndYear: "",
    dlOffset: "",
  });

  const [timezoneStates, setTimezoneStates] = useState({
    timezone: "",
    hours: "",
    minutes: "",
    acronym: "",
    dlMode: "",
    dlStartWeek: "",
    dlEndWeek: "",
    dlStartDay: "",
    dlEndDay: "",
    dlStartMonth: "",
    dlEndMonth: "",
    dlStartHours: "",
    dlEndHours: "",
    dlStartMinutes: "",
    dlEndMinutes: "",
    dlStartDate: "",
    dlEndDate: "",
    dlStartYear: "",
    dlEndYear: "",
    dlOffset: "",
  });

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.timezones.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    setTimezoneStates({
      ...timezoneStates,
      ["timezone"]: validateField("hours"),
      ["dlMode"]: validateField("dlMode"),
      ["dlStartWeek"]:
        timezoneValues["dlMode"] == "recurring"
          ? validateField("dlStartWeek")
          : "",
      ["dlEndWeek"]:
        timezoneValues["dlMode"] == "recurring"
          ? validateField("dlRecEndWeek")
          : "",

      ["dlStartDay"]:
        timezoneValues["dlMode"] == "recurring"
          ? validateField("dlStartDay")
          : "",
      ["dlEndDay"]:
        timezoneValues["dlMode"] == "recurring"
          ? validateField("dlRecEndDay")
          : "",
      ["dlStartMonth"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlStartMonth")
          : "",
      ["dlEndMonth"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlEndMonth")
          : "",
      ["dlStartHours"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlStartHours")
          : "",
      ["dlEndHours"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlEndHours")
          : "",
      ["dlStartMinutes"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlStartMinutes")
          : "",
      ["dlEndMinutes"]:
        timezoneValues["dlMode"] != "disabled"
          ? validateField("dlEndMinutes")
          : "",
      ["dlOffset"]:
        timezoneValues["dlMode"] != "disabled" ? validateField("dlOffset") : "",
    });

    if (!formError) {
      postData();
    }
  };

  // Validate if field is empty
  const validateField = (field) => {
    let status = "";
    if (timezoneValues[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Call the API
    fetch("/api/v1/timezones/edit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        position: timezoneValues.position,
        hours: timezoneValues.hours,
        minutes: timezoneValues.minutes,
        acronym: timezoneValues.acronym,
        dlMode: timezoneValues.dlMode,
        dlStartWeek: timezoneValues.dlStartWeek,
        dlEndWeek: timezoneValues.dlEndWeek,
        dlStartDay: timezoneValues.dlStartDay,
        dlEndDay: timezoneValues.dlEndDay,
        dlStartMonth: timezoneValues.dlStartMonth,
        dlEndMonth: timezoneValues.dlEndMonth,
        dlStartHours: timezoneValues.dlStartHours,
        dlEndHours: timezoneValues.dlEndHours,
        dlStartMinutes: timezoneValues.dlStartMinutes,
        dlEndMinutes: timezoneValues.dlEndMinutes,
        dlStartDate: timezoneValues.dlStartDate,
        dlEndDate: timezoneValues.dlEndDate,
        dlStartYear: timezoneValues.dlStartYear,
        dlEndYear: timezoneValues.dlEndYear,
        dlOffset: timezoneValues.dlOffset,
        selectedDevices: selectedDevices,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while saving the timezone", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Timezone saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTimezoneValues({
      ...timezoneValues,
      [name]: value,
    });
  };

  const handleTimezoneChange = (e) => {
    var timezone = e.value;
    setTimezoneValues({
      ...timezoneValues,
      ["position"]: timezone.position,
      ["hours"]: timezone.offsetHours,
      ["minutes"]: timezone.offsetMinutes,
    });
  };

  const handleDlMode = (dlModeOption) => {
    var dlMode = dlModeOption.value;

    setTimezoneValues({
      ...timezoneValues,
      ["dlMode"]: dlMode.value,
      ["dlStartWeek"]: "",
      ["dlEndWeek"]: "",
      ["dlStartDay"]: "",
      ["dlEndDay"]: "",
      ["dlStartMonth"]: "",
      ["dlEndMonth"]: "",
      ["dlStartHours"]: "",
      ["dlEndHours"]: "",
      ["dlStartMinutes"]: "",
      ["dlEndMinutes"]: "",
      ["dlStartDate"]: "",
      ["dlEndDate"]: "",
      ["dlStartYear"]: "",
      ["dlEndYear"]: "",
      ["dlOffset"]: "",
    });
  };

  const handleSelect = (e, name) => {
    var mode = e.value;
    setTimezoneValues({
      ...timezoneValues,
      [name]: mode.value,
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/timezones/list",
                      }}
                    >
                      Timezones
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Timezone Edit</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Form onSubmit={handleSubmit}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Timezone Configuration</CardTitle>
                </CardHeader>
                <CardBody>
                  {errorMsg.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#FFC0A4",
                        border: "1px solid #ef8157",
                        color: "#66615b",
                        paddingTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <ul>
                        {errorMsg.map((d, index) => (
                          <li key={index}>{d}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  <p>Selected Devices: {selectedDevices.join(", ")}</p>
                  <Row>
                    <Col>
                      <label>Time Zone</label>
                      <FormGroup
                        className={
                          timezoneStates["timezone"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="filterButton"
                          onChange={(option) => {
                            handleTimezoneChange(option);
                          }}
                          options={timezones.map((option) => ({
                            value: {
                              ...option,
                              toString: () =>
                                `${
                                  option.offsetHours +
                                  " " +
                                  option.offsetMinutes +
                                  " " +
                                  option.position
                                }`,
                            },
                            label: `${
                              option.displayTime + " " + option.description
                            }`,
                          }))}
                        />
                        <label className="error">
                          {timezoneStates["timezone"]}
                        </label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <SelectComponent
                        label="Daylight Saving Time Mode"
                        fieldName={"dlMode"}
                        array={daylightMode}
                        stateValue={timezoneStates["dlMode"]}
                        onChange={(option) => {
                          handleDlMode(option);
                        }}
                      />
                    </Col>
                    <Col>
                      <label>Acronym</label>
                      <FormGroup
                        className={
                          timezoneStates["acronym"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          type="acronym"
                          name="acronym"
                          onChange={handleInputChange}
                          value={timezoneValues.acronym}
                        />
                        <label className="error">
                          {timezoneStates["acronym"]}
                        </label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {timezoneValues.dlMode == "disabled" ? (
                    <Button className="btn-round" color="info" type="submit">
                      Submit
                    </Button>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
              {timezoneValues.dlMode == "recurring" ? (
                <Row>
                  <Col>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col>
                            <h5>Start Date</h5>
                            <SelectComponent
                              label="Week #"
                              fieldName={"dlStartWeek"}
                              array={daylightWeekNumbers}
                              stateValue={timezoneStates["dlStartWeek"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartWeek");
                              }}
                            />
                            <SelectComponent
                              label="Day"
                              fieldName={"dlStartDay"}
                              array={weekdays}
                              stateValue={timezoneStates["dlStartDay"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartDay");
                              }}
                            />
                            <SelectComponent
                              label="Month"
                              fieldName={"dlStartMonth"}
                              array={months}
                              stateValue={timezoneStates["dlStartMonth"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartMonth");
                              }}
                            />
                            <SelectComponent
                              label="Hours"
                              fieldName={"dlStartHours"}
                              array={hours}
                              stateValue={timezoneStates["dlStartHours"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartHours");
                              }}
                            />
                            <SelectComponent
                              label="Minutes"
                              fieldName={"dlStartMinutes"}
                              array={daylightMinutes}
                              stateValue={timezoneStates["dlStartMinutes"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartMinutes");
                              }}
                            />
                            <SelectComponent
                              label="Offset"
                              fieldName={"dlOffset"}
                              array={offsetMinutes}
                              stateValue={timezoneStates["dlOffset"]}
                              onChange={(option) => {
                                handleSelect(option, "dlOffset");
                              }}
                            />
                            {timezoneValues.dlMode == "recurring" ? (
                              <Button
                                className="btn-round"
                                color="info"
                                type="submit"
                              >
                                Submit
                              </Button>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col>
                            <h5>End Date</h5>
                            <SelectComponent
                              label="Week #"
                              fieldName={"dlEndWeek"}
                              array={daylightWeekNumbers}
                              stateValue={timezoneStates["dlEndWeek"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndWeek");
                              }}
                            />
                            <SelectComponent
                              label="Day"
                              fieldName={"dlEndDay"}
                              array={weekdays}
                              stateValue={timezoneStates["dlEndDay"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndDay");
                              }}
                            />
                            <SelectComponent
                              label="Month"
                              fieldName={"dlEndMonth"}
                              array={months}
                              stateValue={timezoneStates["dlEndMonth"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndMonth");
                              }}
                            />
                            <SelectComponent
                              label="Hours"
                              fieldName={"dlEndHours"}
                              array={hours}
                              stateValue={timezoneStates["dlEndHours"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndHours");
                              }}
                            />
                            <SelectComponent
                              label="Minutes"
                              fieldName={"dlEndMinutes"}
                              array={daylightMinutes}
                              stateValue={timezoneStates["dlEndMinutes"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndMinutes");
                              }}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              {timezoneValues.dlMode == "nonRecurring" ? (
                <Row>
                  <Col>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col>
                            <h5>Start Date</h5>
                            <SelectComponent
                              label="Month"
                              fieldName={"dlStartMonth"}
                              array={months}
                              stateValue={timezoneStates["dlStartMonth"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartMonth");
                              }}
                            />
                            <SelectComponent
                              label="Date"
                              fieldName={"dlStartDate"}
                              array={Array.from({ length: 31 }, (_, index) => ({
                                value: index + 1,
                                label: index + 1,
                              }))}
                              stateValue={timezoneStates["dlStartDate"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartDate");
                              }}
                            />
                            <SelectComponent
                              label="Year"
                              fieldName={"dlStartYear"}
                              array={Array(98)
                                .fill()
                                .map((_, index) => {
                                  const year = 2000 + index;
                                  return {
                                    value: year.toString(),
                                    label: year.toString(),
                                  };
                                })}
                              stateValue={timezoneStates["dlStartYear"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartYear");
                              }}
                            />
                            <SelectComponent
                              label="Hours"
                              fieldName={"dlStartHours"}
                              array={hours}
                              stateValue={timezoneStates["dlStartHours"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartHours");
                              }}
                            />
                            <SelectComponent
                              label="Minutes"
                              fieldName={"dlStartMinutes"}
                              array={daylightMinutes}
                              stateValue={timezoneStates["dlStartMinutes"]}
                              onChange={(option) => {
                                handleSelect(option, "dlStartMinutes");
                              }}
                            />
                            <SelectComponent
                              label="Offset"
                              fieldName={"dlOffset"}
                              array={offsetMinutes}
                              stateValue={timezoneStates["dlOffset"]}
                              onChange={(option) => {
                                handleSelect(option, "dlOffset");
                              }}
                            />

                            {timezoneValues.dlMode == "nonRecurring" ? (
                              <Button
                                className="btn-round"
                                color="info"
                                type="submit"
                              >
                                Submit
                              </Button>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col>
                            <h5>End Date</h5>
                            <SelectComponent
                              label="Month"
                              fieldName={"dlEndMonth"}
                              array={months}
                              stateValue={timezoneStates["dlEndMonth"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndMonth");
                              }}
                            />
                            <SelectComponent
                              label="Date"
                              fieldName={"dlEndDate"}
                              array={Array.from({ length: 31 }, (_, index) => ({
                                value: index + 1,
                                label: index + 1,
                              }))}
                              stateValue={timezoneStates["dlEndDate"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndDate");
                              }}
                            />
                            <SelectComponent
                              label="Year"
                              fieldName={"dlEndYear"}
                              array={Array(98)
                                .fill()
                                .map((_, index) => {
                                  const year = 2000 + index;
                                  return {
                                    value: year.toString(),
                                    label: year.toString(),
                                  };
                                })}
                              stateValue={timezoneStates["dlEndYear"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndYear");
                              }}
                            />
                            <SelectComponent
                              label="Hours"
                              fieldName={"dlEndHours"}
                              array={hours}
                              stateValue={timezoneStates["dlEndHours"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndHours");
                              }}
                            />
                            <SelectComponent
                              label="Minutes"
                              fieldName={"dlEndMinutes"}
                              array={daylightMinutes}
                              stateValue={timezoneStates["dlEndMinutes"]}
                              onChange={(option) => {
                                handleSelect(option, "dlEndMinutes");
                              }}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TimezoneEdit;
